/**
 * @generated SignedSource<<b85d3a6a45b75b60236f2aa1495d7fbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useHandleTemplateChangeIssueForm$data = {
  readonly __typename: "IssueForm";
  readonly __id: string;
  readonly assignees: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename?: "User";
        readonly avatarUrl?: string;
        readonly id?: string;
        readonly login?: string;
        readonly name?: string | null | undefined;
        readonly profileResourcePath?: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly filename: string;
  readonly labels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly color: string;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly nameHTML: string;
        readonly url: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "ProjectV2";
        readonly closed: boolean;
        readonly hasReachedItemsLimit: boolean;
        readonly id: string;
        readonly number: number;
        readonly title: string;
        readonly url: string;
        readonly viewerCanUpdate: boolean;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly title: string | null | undefined;
  readonly type: {
    readonly color: IssueTypeColor;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly isEnabled: boolean;
    readonly name: string;
    readonly pinnedFields: ReadonlyArray<{
      readonly __typename: "IssueFieldDate";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
    } | {
      readonly __typename: "IssueFieldNumber";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
    } | {
      readonly __typename: "IssueFieldSingleSelect";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
    } | {
      readonly __typename: "IssueFieldText";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFormElements_templateElements">;
  readonly " $fragmentType": "useHandleTemplateChangeIssueForm";
};
export type useHandleTemplateChangeIssueForm$key = {
  readonly " $data"?: useHandleTemplateChangeIssueForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHandleTemplateChangeIssueForm">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useHandleTemplateChangeIssueForm"
};

(node as any).hash = "2b91a8d5f416e7948a2fa0b96775011d";

export default node;
